/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Layout from "../Component/Layout/Layout";
import BannerSection from "../Component/BannerSection";
import MenuSearchbar from "../Component/Menu/MenuSearchbar";
import MenuCart from "../Component/Menu/MenuCart";
import { axiosInstance } from "../Component/utils/axiosInstance";
import Loader from "../Component/Loader";
import ShareSocialModal from "../Component/ShareSocialModal";

const Menu = () => {
  const [allProduct, setAllProduct] = useState([]);
  const [loader, setloader] = useState(false);

  const getAllProduct = async () => {
    setloader(true);
    try {
      await axiosInstance.get("user/product").then((response) => {
        if (response?.data?.status === true) {
          setloader(false);

          setAllProduct(response?.data?.products);
        }
      });
    } catch (error) {
      setloader(false);
    }
  };

  useEffect(() => {
    getAllProduct();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [url, setUrl] = useState("");
  return (
    <Layout>
      <BannerSection
        heading="Menu"
        image="/images/menu_banner.webp"
        description="Menu"
      />
      <section class="menu_page mt_100 xs_mt_70 mb_100 xs_mb_70">
        <div class="container">
          {/* <MenuSearchbar /> */}
          {loader ? (
            <Loader />
          ) : (
            <div className="row">
              <h1>Menus</h1>
              {allProduct.length > 0 ? (
                allProduct.map((e, i) => (
                  <MenuCart
                    setShowModal={setShowModal}
                    setUrl={setUrl}
                    productData={e}
                  />
                ))
              ) : (
                <h1 className="text-center">Not Menu Found !</h1>
              )}
            </div>
          )}
        </div>
      </section>
      <ShareSocialModal
        showModal={showModal}
        handleClose={handleClose}
        url={url}
      />
    </Layout>
  );
};

export default Menu;
